module.exports = __webpack_public_path__ + "img/bnr_adobe_reader.c86cb8c6.jpg";